import { gsap } from 'gsap'
import { signal } from 'services/SignalsService'
import { reelsSettings, spinSettings } from 'settings/custom/reels'

export default class OverReelEntity extends PIXI.Container {
  constructor() {
    super()
    this.isFS = false
    this.items = []
    this.spinModel = game.models.SpinModel.get()
    this.winModel = game.models.WinModel.get()
    this.settings = spinSettings.turbo

    signal.on('FREESPINS-MODE', (value) => this.isFS = value)
    signal.on('SCATTER:START', (id) => this.start(id, 'scatter'))
    signal.on('SCATTER:STOP', (id) => this.stop(id, 'scatter'))
    signal.on('ACTION:REQUEST-RESPIN', () => this.check('spin'))
    signal.on('BEGIN-STOP-REEL', () => this.stopAll('spin'))
    signal.on('ACTION:EXPANDING-WILD', () => this.check('wild'))
    signal.on('REELS-START', () => this.check('move'))
  }

  check(name) {
    switch (name) {
      case 'spin' : this.items.forEach((item, idx) => spinSettings.respin.infinity ? this.spinModel.respin.includes(idx) && this.start(idx, name) : !this.spinModel.respin.includes(idx) && this.start(idx, name))
        break
      case 'wild' : this.items.forEach((item, idx) => this.winModel.wild
        .filter(([x]) => x == idx)
        .forEach(((value) => this.start(idx, name, value))))
        break
      case 'move': reelsSettings.expanding && this.settings.reelfsDelay && this.isFS
        ? this.stopAll('wild')
        : this.move()
    }
  }

  start(id, name, coord) {
    this.items[id].begin(name, coord)
  }

  stop(id, name) {
    this.items[id].end(name)
  }

  stopAll(name) {
    this.items.forEach((item) => item.end(name))
  }

  move() {
    const promises = this.items.map((item) => {
      return new Promise((res) => {
        const startTween = item.y
        gsap.to(
          item,
          this.settings.start ? this.settings.start.time : 0,
          {
            y: item.height * 2,
            ease: this.settings.start ? this.settings.start.ease : 'none',
            onComplete: () => {
              item.y = startTween
              res()
            },
          },
        )
      })
    })
    Promise.all(promises).then(() => this.stopAll('wild'))
  }

  register = (type, object) => {
    if (type == 'OverReelAnimation') {
      this.items.push(object)
    }
  }
}
